const MAX_BYTES_BMP = 3;
export const cleanNonUtfBMPChars = (input: string) => {
    const chars = [...input];
    let output = '';
    for (let i = 0; i < chars.length; i++) {
        const char = chars[i];
        const byteCount = new Blob([char]).size;
        if (byteCount <= MAX_BYTES_BMP) {
            output += char;
        }
    }
    return output;
};

export const sanitizeText = (value: string): string =>
    cleanNonUtfBMPChars(value);
